import { render, staticRenderFns } from "./subsidyDetail.vue?vue&type=template&id=1339651f&scoped=true"
import script from "./subsidyDetail.vue?vue&type=script&lang=js"
export * from "./subsidyDetail.vue?vue&type=script&lang=js"
import style0 from "./subsidyDetail.vue?vue&type=style&index=0&id=1339651f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339651f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1339651f')) {
      api.createRecord('1339651f', component.options)
    } else {
      api.reload('1339651f', component.options)
    }
    module.hot.accept("./subsidyDetail.vue?vue&type=template&id=1339651f&scoped=true", function () {
      api.rerender('1339651f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/activitySetting/subsidyDetail.vue"
export default component.exports